import { serverURL } from "../utils";

const headers = {
  "Content-Type": "application/json",
};

export const getMemberSignupProof = async () => {
  const response = await fetch(`${serverURL()}/members/signup-proof`, { cache: "no-store" });
  const data = await response.json();
  if (!response.ok) throw new Error(data.message || "Unable to load signup form.");
  return data.proof;
};

export const resendMemberVerification = async (emailAddress, formProof, website = "") => {
  const response = await fetch(`${serverURL()}/members/resend-verification`, {
    method: "POST", headers, body: JSON.stringify({ emailAddress, formProof, website }),
  });
  const data = await response.json();
  if (!response.ok) throw new Error(data.message || "Unable to resend verification.");
  return data;
};

export const createMember = async (emailAddress, formProof, website = "") => {
  const response = await fetch(`${serverURL()}/members/signup`, {
    method: "POST",
    headers,
    body: JSON.stringify({ emailAddress, formProof, website }),
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message);
  }

  return data;
};

export const validateMemberCode = async (validationObj) => {
  const response = await fetch(`${serverURL()}/members/validate-code`, {
    method: "POST",
    headers,
    body: JSON.stringify(validationObj),
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message);
  }

  return data;
};
